import { noop } from '@/utils';

import { createContext } from 'react';

export type SignInOptions = {
  isProfileCompleted?: boolean;
  /** Seed в query cache профиля, чтобы модалка не мигала до GET /people */
  legal_agreement_accepted?: boolean;
  legal_agreement_version?: number | null;
};

export interface AuthContextValue {
  userId: number | null;
  isAuthorized: boolean;
  isClient: boolean;
  isLoading: boolean;
  /** true — с бэка пришло, что профиль не заполнен (validate_code и т.п.) */
  clientNeedsProfileSetup: boolean;
  signIn(userId: number, isClient: boolean, options?: SignInOptions): void;
  /** После успешного сохранения профиля снимает флаг и очищает sessionStorage */
  markClientProfileComplete(): void;
  signOut(): void;
}

export const AuthContext = createContext<AuthContextValue>({
  userId: null,
  isAuthorized: false,
  isClient: true,
  isLoading: true,
  clientNeedsProfileSetup: false,
  signIn: noop,
  markClientProfileComplete: noop,
  signOut: noop,
});
